import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DaybookService = {
  closeSummary: async (startDate, endDate) => {
    try {
      const response = await apiService.post(`/dayclose/closeandsummary`);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  // orderSummary: async ({
  //   fromDate = "",
  //   toDate = "",}) => {
  //   const response = await apiService.get(
  //     `/dayclose/ordersummaries`
  //   );
  //   return response.data;
  // },
  orderSummary: async ({ startDate = "", endDate = "" } = {}) => {
    try {
      const params = new URLSearchParams({
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
      });

      const response = await apiService.get(
        `/dayclose/ordersummaries?${params.toString()}`
      );

      return response.data;
    } catch (err) {
      console.error("Error getting order summary:", err);
      throw err;
    }
  },
  paymentTypeSummary: async (startDate, endDate) => {
    const response = await apiService.get(`/dayclose/paymenttypesummary`);
    return response.data;
  },
};

export default DaybookService;
